<template>
    <div>
        <div class="inline-flex items-center mr-5" v-if="canShow">
            <span class="text-sm font-bold">Enable Companion Pass Mode</span>
            <button
                type="button"
                class="relative ml-2 mr-2 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                @click="userPassEnabled = !userPassEnabled"
                :class="{
                    'bg-gray-200 dark:bg-slate-700': !userPassEnabled,
                    'bg-orange': userPassEnabled,
                }"
                role="switch"
                aria-checked="true"
                :disabled="fiveTwentyFour"
                id="hs-companion-pass-toggle"
            >
                <input
                    type="text"
                    class="hidden"
                    v-model="userPassEnabled"
                    name="card_status"
                />
                <span
                    aria-hidden="true"
                    class="inline-block h-5 w-5 transform rounded-full shadow ring-0 transition duration-200 ease-in-out"
                    :class="{
                        'translate-x-5 bg-white dark:bg-slate-800': userPassEnabled,
                        'translate-x-0 bg-white dark:bg-slate-800': !userPassEnabled,
                    }"
                ></span>
                <i
                    class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                    :class="{
                        'opacity-100 delay-300': userPassEnabled,
                        'opacity-0': !userPassEnabled,
                    }"
                ></i>
            </button>
        </div>
        <div v-if="fiveTwentyFour && settingsPage" class="mt-5 mb-5 w-full">
            <div class="w-full">
                    <div class="rounded-md bg-red-50 dark:bg-red-900/10 p-4">
                    <div class="rounded-md bg-red-50 p-4">
                        <div class="flex">
                            <div
                                class="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                            >
                                <svg
                                    class="h-6 w-6 text-red-600"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                    ></path>
                                </svg>
                            </div>
                            <div class="ml-3">
                                <h3 class="text-base font-medium text-red-800 dark:text-red-200">
                                    You're Over 5/24
                                </h3>
                                <div class="mt-2 text-sm text-red-700 dark:text-red-200/80">
                                    <p>
                                        You're over 5/24, which means you can't
                                        earn the Companion Pass using the
                                        strategy we outline here since you're
                                        unable to open any Chase cards.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useAppStore } from "@/store/app";
import { useCompanionPassStore } from "@/store/companionpass";
import { notify } from "notiwind";

export default {
    name: "CompanionPassToggle",
    props: {
        settingsPage: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, [
            "passEnabled",
            "fiveTwentyFour",
            "fiveTwentyFourModal",
            "canDismiss524Alert",
        ]),
        userPassEnabled: {
            set(val) {
                this.setPassEnabled(val);
                const group = this.passEnabled ? "success" : "error";
                const title = this.passEnabled ? "Enabled" : "Disabled";
                const text = this.passEnabled ? "enabled" : "disabled";
                notify(
                    {
                        group: group,
                        title: "Southwest Companion Pass Mode " + title,
                        text:
                            "You have " +
                            text +
                            " Southwest Companion Pass Mode",
                    },
                    4000
                );
            },
            get() {
                return this.passEnabled && !this.fiveTwentyFour;
            },
        },
        canShow() {
            if (this.settingsPage) {
                return true;
            }

            return !this.fiveTwentyFour || this.canDismiss524Alert;
        },
    },
    watch: {
        userPassEnabled() {
            this.togglePass();
        },
    },
    methods: {
        ...mapActions(useAppStore, ["setShowAffiliateModal"]),
        ...mapActions(useCompanionPassStore, [
            "getPassData",
            "setPassEnabled",
            "togglePass",
        ]),
    },
    mounted() {
        this.getPassData();
    },
};
</script>
